import { makeStyles } from "tss-react/mui";

export const useHeaderHelpItemStyles = makeStyles()((theme) => ({
  helpAction: {
    alignSelf: "center", 
    justifyContent: "center",
    height: theme.spacing(4), 
    width: theme.spacing(4),
    color: "var(--color-neutral-700)",
    "&:hover": {
      color: "var(--color-neutral-500)",
    },
  },
  helpActionActive:{
    color: "var(--color-neutral-400)",
  },
  helpIcon: {
    height: theme.spacing(4), 
    width: theme.spacing(4),
  },
  helpDrawer: {
    "& .MuiPaper-root":{
      top:"var(--header-height)",
      height:"calc(100% - var(--header-height))",
      minWidth: "325px",
    }
  },
}));
